import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard, Zap, Trophy } from 'lucide-react';
import { trackPixelEvent } from './facebookPixel';
type Plan = 'esencial' | 'elite';
const CHECKOUT_URLS: Record<Plan, string> = {
  esencial: 'https://astroser.com.ar/checkouts/cn/hWNDBs7AswUiZGHZ7oqXYj3K/en-ar?_r=AQABE82iVwpUllaOIpGXPdMA_Lo4jZ6y_0qOGMXMk9sIPss',
  elite: 'https://astroser.com.ar/checkouts/cn/hWNDBs7SVJft3lR0KhK44BMY/en-ar?_r=AQABCVCsthlCGHoaHRB9h11ziDa26a2lya7bRxiwCgA0BGA'
};
export function PricingSection() {
  const [selected, setSelected] = useState<Plan>('elite');
  const handleCheckout = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: selected === 'elite' ? 'Megapack Élite' : 'Pack Esencial',
      value: selected === 'elite' ? 27990 : 18990,
      currency: 'ARS'
    });
    window.location.href = CHECKOUT_URLS[selected];
  };
  return <section id="precio" className="py-20 px-4 bg-mystic-900 relative" data-id="element-185">
      <div className="max-w-xl mx-auto" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-mystic-800/60 border border-mystic-700 rounded-3xl p-6 md:p-8 shadow-2xl" data-id="element-187">
          {/* Header */}
          <div className="text-center mb-8" data-id="element-188">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-3" data-id="element-189">
              Elegí tu Pack:
            </h2>
            <p className="text-base md:text-lg text-lilac-300 font-medium" data-id="element-190">
              Las dos opciones incluyen los 6 Bonus estratégicos
            </p>
          </div>

          {/* Pack Esencial option */}
          <button type="button" onClick={() => setSelected('esencial')} aria-pressed={selected === 'esencial'} className={`w-full text-left rounded-2xl p-5 mb-5 flex items-center gap-4 transition-all ${selected === 'esencial' ? 'bg-mystic-900 border-2 border-gold-500 shadow-[0_0_25px_rgba(212,175,55,0.15)]' : 'bg-mystic-900/40 border-2 border-mystic-700 hover:border-mystic-600'}`} data-id="element-191">
            <span className={`shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'esencial' ? 'border-gold-500' : 'border-mystic-600'}`} data-id="element-192">
              {selected === 'esencial' && <span className="w-3 h-3 rounded-full bg-gold-500" data-id="element-193" />}
            </span>

            <div className="flex-grow min-w-0" data-id="element-194">
              <div className="flex items-center gap-2" data-id="element-195">
                <span className="text-2xl" data-id="element-196">📘</span>
                <span className="font-bold text-white text-lg leading-tight" data-id="element-197">
                  PACK ESENCIAL
                </span>
              </div>
              <p className="text-sm text-slate-400 mt-1" data-id="element-198">12 Tomos + 6 Bonus</p>
            </div>

            <div className="text-right shrink-0" data-id="element-199">
              <div className="text-slate-500 line-through text-sm" data-id="element-200">$29.990</div>
              <div className="text-2xl font-bold text-white" data-id="element-201">$18.990</div>
            </div>
          </button>

          {/* Megapack Élite option */}
          <button type="button" onClick={() => setSelected('elite')} aria-pressed={selected === 'elite'} className={`w-full text-left rounded-2xl p-5 mb-6 flex items-start gap-4 transition-all ${selected === 'elite' ? 'bg-mystic-900 border-2 border-gold-500 shadow-[0_0_30px_rgba(212,175,55,0.2)]' : 'bg-mystic-900/40 border-2 border-mystic-700 hover:border-mystic-600'}`} data-id="element-202">
            <span className={`shrink-0 mt-1 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'elite' ? 'border-gold-500' : 'border-mystic-600'}`} data-id="element-203">
              {selected === 'elite' && <span className="w-3 h-3 rounded-full bg-gold-500" data-id="element-204" />}
            </span>

            <div className="flex-grow min-w-0" data-id="element-205">
              <div className="flex items-center gap-2 mb-2" data-id="element-206">
                <Trophy className="w-6 h-6 text-gold-400 shrink-0" data-id="element-207" />
                <span className="font-bold text-gold-400 text-lg leading-tight" data-id="element-208">
                  MEGAPACK ÉLITE
                </span>
              </div>

              <div className="flex flex-wrap gap-2 mb-2" data-id="element-209">
                <span className="inline-flex items-center gap-1 bg-gold-500/20 text-gold-300 text-[11px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider" data-id="element-210">
                  ⭐ MÁS ELEGIDO
                </span>
                <span className="inline-flex items-center bg-green-500/15 text-green-400 text-[11px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider" data-id="element-211">
                  AHORRÁS $10.000
                </span>
              </div>

              <p className="text-sm text-slate-300" data-id="element-212">
                12 Tomos + 6 Bonus + 2 EBOOKS ÉLITE
              </p>
            </div>

            <div className="text-right shrink-0" data-id="element-213">
              <div className="text-slate-500 line-through text-sm" data-id="element-214">$49.990</div>
              <div className="text-2xl md:text-3xl font-bold text-gold-400" data-id="element-215">
                $27.990
              </div>
            </div>
          </button>

          {/* CTA */}
          <motion.button whileHover={{
          scale: 1.01
        }} whileTap={{
          scale: 0.99
        }} onClick={handleCheckout} className="w-full py-5 rounded-2xl bg-gradient-to-r from-gold-500 to-gold-600 hover:from-gold-400 hover:to-gold-500 text-mystic-900 font-bold text-base md:text-lg shadow-[0_0_30px_rgba(212,175,55,0.3)] transition-all flex flex-col items-center gap-1" data-id="element-216">
            <span data-id="element-217">
              {selected === 'elite' ? 'SÍ, QUIERO EL MEGAPACK ÉLITE' : 'SÍ, QUIERO EL PACK ESENCIAL'}
            </span>
            <span aria-hidden="true" data-id="element-218">→</span>
          </motion.button>

          <p className="text-center text-sm text-slate-400 italic mt-4" data-id="element-219">
            La opción más elegida por mujeres que no quieren seguir repitiendo
            el mismo patrón
          </p>

          {/* Trust badges */}
          <div className="grid grid-cols-2 gap-x-4 gap-y-4 mt-8 pt-6 border-t border-mystic-700/50 text-sm text-slate-300" data-id="element-220">
            <span className="flex items-center gap-2" data-id="element-221">
              <Lock className="w-5 h-5 text-slate-400" data-id="element-222" /> Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-223">
              <Zap className="w-5 h-5 text-gold-400" data-id="element-224" /> Acceso en 5 min
            </span>
            <span className="flex items-center gap-2" data-id="element-225">
              <ShieldCheck className="w-5 h-5 text-green-400" data-id="element-226" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-227">
              <CreditCard className="w-5 h-5 text-slate-400" data-id="element-228" /> Tarjeta ·
              Transferencia
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}